import WelcomeView from '@/ui/shared/views/Welcome/WelcomeView.vue'
import HomeView from '@/ui/excel/views/HomeView/HomeView.vue'
import Redirect from '@/ui/shared/views/Redirect/Redirect.vue'
import PowerPointHome from '@/ui/powerpoint/views/HomeView/HomeView.vue'
import RevDetailView from '@/ui/powerpoint/views/RevDetailView/RevDetailView.vue'
import store from '@/store/index.js'

const routes = [
  {
    path: '/',
    redirect: '/welcome',
  },
  {
    path: '/welcome',
    name: 'welcome',
    meta: { layout: 'EmptyLayout' },
    component: WelcomeView,
  },
  {
    path: '/excel',
    name: 'excel',
    component: HomeView,
    beforeEnter: requireAuth,
  },
  {
    path: '/powerpoint',
    name: 'powerpoint',
    component: PowerPointHome,
    beforeEnter: requireAuth,
  },
  {
    path: '/redirect',
    component: Redirect,
    meta: {
      layout: 'EmptyLayout',
    },
  },
  {
    name: 'revDetail',
    path: '/rev-detail/:organizationId/:revId/:revType',
    component: RevDetailView,
    beforeEnter: requireAuth,
    props: true,
  },
]

function requireAuth(to, from, next) {
  console.log(`Logged in status is ${store.access.isLoggedIn()}`)
  if (!store.access.isLoggedIn()) {
    console.log('User is not logged in, redirecting to home page')
    return next({
      path: '/welcome',
      query: { redirect: to.fullPath },
    })
  }

  return next()
}

export default routes
